










import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import LandingFooter from '@/components/Footer.vue';
import LandingHeader from '@/components/Header.vue';


@Component({
  name: 'default-layout',
  components: {
    LandingHeader,
    LandingFooter,
  },
})
export default class DefaultLayout extends Vue {
  @Prop({ type: Boolean })
  showFooter!: boolean;
}
